module.exports = __webpack_public_path__ + "img/rightside_300.0863414f.png";